module.exports = __webpack_public_path__ + "static/media/servicos.68f47213.png";